module.exports = __webpack_public_path__ + "img/face-recognition.5e11450f.png";